import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MultiRegistrationService } from './multi-registration.service';
import { NgIf } from '@angular/common';
import { MultiRegistrationFormComponent } from './multi-registration-form.component';
import { IEventSettings, IField, IObjectWithId } from '../interfaces';
import { MultiRegistrationConfig, UIState } from '@azavista/participants/dist/event-app/multiregistration/multiregistration-controller';
import { ElementId } from 'src/app/interfaces';

@Component({
  selector: 'aza-rws-multi-registration',
  imports: [
    NgIf,
    MultiRegistrationFormComponent,
  ],
  templateUrl: `./multi-registration.component.html`,
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MultiRegistrationComponent {
    @Input({
        required: true,
    })
    allParticipantFields?: IField[];

    @Input({
        required: true,
    })
    eventParticipant?: IObjectWithId;

    @Input({
        required: true,
    })
    eventSettings?: IEventSettings;

    get uiState(): UIState | undefined {
        return this.multiRegistrationSvc.uiState;
    }

    get config(): MultiRegistrationConfig | undefined {
        return this.multiRegistrationSvc.config;
    }

    attrId = ElementId.azaRwsMultiRegistrationComponentContainer;

    constructor(public multiRegistrationSvc: MultiRegistrationService) {}
}
